import { useState, useEffect } from 'react';
import { useRaces } from '@/hooks/useRaces';
import { useSponsors } from '@/hooks/useSponsors';
import { useSponsorsActions } from './useSponsorsActions';
import SponsorsManagerView from './sponsorsmanager.view';

interface SponsorsManagerOwnProps {
  raceId?: string;
}

const SponsorsManager: React.FC<SponsorsManagerOwnProps> = ({ raceId: raceIdProp }) => {
  const [selectedRaceIdState, setSelectedRaceIdState] = useState('');
  const [searchQuery, setSearchQuery] = useState('');

  const isEmbedded = !!raceIdProp;
  const selectedRaceId = isEmbedded ? raceIdProp : selectedRaceIdState;

  const { data: races = [] } = useRaces();
  const { data: sponsors = [], isLoading: loading } = useSponsors(selectedRaceId);

  useEffect(() => {
    if (!isEmbedded && races.length > 0 && !selectedRaceIdState) {
      setSelectedRaceIdState(races[0].id);
    }
  }, [races, selectedRaceIdState, isEmbedded]);

  const actions = useSponsorsActions(selectedRaceId, sponsors.length);

  const filteredSponsors = sponsors.filter(
    (s: any) =>
      s.name.toLowerCase().includes(searchQuery.toLowerCase()) ||
      (s.websiteUrl && s.websiteUrl.toLowerCase().includes(searchQuery.toLowerCase()))
  );

  return (
    <SponsorsManagerView
      races={isEmbedded ? [] : races}
      selectedRaceId={selectedRaceId}
      setSelectedRaceId={isEmbedded ? () => {} : setSelectedRaceIdState}
      searchQuery={searchQuery}
      setSearchQuery={setSearchQuery}
      loading={loading}
      filteredSponsors={filteredSponsors}
      handleAdd={actions.handleAdd}
      handleEdit={actions.handleEdit}
      handleDelete={actions.handleDelete}
      isDialogOpen={actions.isDialogOpen}
      setIsDialogOpen={actions.setIsDialogOpen}
      editingSponsor={actions.editingSponsor}
      useExternalImage={actions.useExternalImage}
      setUseExternalImage={actions.setUseExternalImage}
      formData={actions.formData}
      setFormData={actions.setFormData}
      uploading={actions.uploading}
      handleImageUpload={actions.handleImageUpload}
      handleSubmit={actions.handleSubmit}
      deleteTarget={actions.deleteTarget}
      setDeleteTarget={actions.setDeleteTarget}
      confirmDelete={actions.confirmDelete}
      embedded={isEmbedded}
    />
  );
};

export default SponsorsManager;
